export const breakpoints = {
  sm: "512px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  xxl: "1536px",
};

export const defaultTheme = {
  breakpoints: [
    breakpoints.sm,
    breakpoints.md,
    breakpoints.lg,
    breakpoints.xl,
    breakpoints.xxl,
  ],
};
